var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/payescapeproduct/viewmodels/index',["require", "exports", "common/viewmodelbase", "models/portal", "services/navigator", "services/settings"], function (require, exports, Common, Portal, Navigator, Configuration) {
    "use strict";
    var PayescapeProductViewModel = (function (_super) {
        __extends(PayescapeProductViewModel, _super);
        function PayescapeProductViewModel() {
            _super.call(this);
            this.breadCrumb = new Portal.ModuleBreadCrumbItemHolder();
            this.cdnEndPoint = Configuration.Settings.environment.getCustomValue("CdnEndPoint");
            this.productImage = this.cdnEndPoint + "content/images/payescape_product_page_logo.png";
            this.testimonials = [];
            this.toolkitVideos = [];
            this.informationToSendToClient = [];
            this.initializeTestimonials();
            this.initializeToolkitVideos();
            this.initializeInformationToSendToClient();
            this.title = "PayescapeProduct";
            ko.track(this, ["tabSelected", "testimonials"]);
        }
        PayescapeProductViewModel.prototype.onActivated = function (context) {
            this.tabSelected = 0;
            this.shopId = context.queryString.shopId;
            var parameter = context.path.split('/');
            var calledFromTools = parameter[1] != null ? JSON.parse(parameter[1]) : null;
            this.createPayescapeCrumb();
            this.spliceLastBreadcrumbs(context, calledFromTools);
            this.getPayescapeProductDetails();
            this.createPayescapeProductDetailsCrumb();
        };
        PayescapeProductViewModel.prototype.initializeTestimonials = function () {
            var testimonial1 = {
                image: this.cdnEndPoint + "content/images/andrew_keates_logo.png",
                name: "Andrew Keates & Associates",
                text: '“As my practice had continued to grow and with the addition of auto enrolment, I reached the point where I either had to employ an additional payroll assistant or look to outsource. Having analysed the situation and the costs involved, outsourcing was not only the best value option but also offered the least risk, providing me with the least amount of hassle”' + '<br /><br />' +
                    '“From our very first meeting with Payescape through to their continued management of our entire payroll.Payescape have been incredibly professional providing me with exceptional service and I would happily recommend their services”'
            };
            var testimonial2 = {
                image: "",
                name: "Eastside Accountancy Services",
                text: '“As a busy accountancy practice, we found that our wages bureau was expanding to the limit of our capacity and ability to provide a good reliable service. <br />We were introduced to Payescape and they took over all of the payroll functions. <br />Over the years we have maintained constant contact usually for wages information on behalf of clients in the course of Accounts preparation”' +
                    '<br /><br />' + '“Payescape have been unfailing in their speedy provision of reliable data which is most helpful to the efficiency of our service. They are also most helpful with queries regarding the intricacies of Payroll and Wages. We recommend them at every opportunity”'
            };
            this.testimonials.push(testimonial1);
            this.testimonials.push(testimonial2);
        };
        PayescapeProductViewModel.prototype.initializeToolkitVideos = function () {
            var video1 = {
                name: "Accountants Demo",
                link: "https://www.youtube.com/watch?v=Alc-xS6nvv8"
            };
            var video2 = {
                name: "Add Employees",
                link: "https://www.youtube.com/watch?v=vzZ6auTNNRs"
            };
            var video3 = {
                name: "ESS Security",
                link: "https://www.youtube.com/watch?v=Ngb-2dXmuCE"
            };
            var video4 = {
                name: "Leavers",
                link: "https://www.youtube.com/watch?v=Q2WUGEYFHjA"
            };
            var video5 = {
                name: "Pay Components",
                link: "https://www.youtube.com/watch?v=Xs0P_bEWrwo"
            };
            var video6 = {
                name: "Pay Rates",
                link: "https://www.youtube.com/watch?v=8VAu5IAFlfc"
            };
            var video7 = {
                name: "Bank Details",
                link: "https://www.youtube.com/watch?v=YXCe4E2rzcE"
            };
            var video8 = {
                name: "Submit a Payroll",
                link: "https://www.youtube.com/watch?v=dgl0BzRx9lM"
            };
            this.toolkitVideos.push(video1);
            this.toolkitVideos.push(video2);
            this.toolkitVideos.push(video3);
            this.toolkitVideos.push(video4);
            this.toolkitVideos.push(video5);
            this.toolkitVideos.push(video6);
            this.toolkitVideos.push(video7);
            this.toolkitVideos.push(video8);
        };
        PayescapeProductViewModel.prototype.initializeInformationToSendToClient = function () {
            var informationToSendToClient1 = {
                url: "https://ocuksbstatic.blob.core.windows.net/iserve/Payescape-Flyer.pdf",
                text: 'Payescape Flyer',
                icon: "fa-file-text-o"
            };
            this.informationToSendToClient.push(informationToSendToClient1);
        };
        PayescapeProductViewModel.prototype.createPayescapeCrumb = function () {
            // initial add of Payescape breadcrumb
            if (this.breadCrumb.items.length === 0) {
                this.addPayescapeCrumbToBreadcrumbItems();
            }
        };
        PayescapeProductViewModel.prototype.spliceLastBreadcrumbs = function (context, calledFromTools) {
            // calledFromTools - flag to see where PayescapeProduct is called from (null - called from Dashboard, not null - called from Tools)
            if (this.breadCrumb.items.length > 1) {
                // for the Payescape page in Tools
                if (calledFromTools == true) {
                    this.breadCrumb.items.splice(this.breadCrumb.items.length - 1, 1);
                }
                else {
                    this.breadCrumb.items.splice(this.breadCrumb.items.length - 2, 2);
                }
            }
            else {
                // for the Payescape page in Tools
                if (calledFromTools == true) {
                    this.breadCrumb.items.splice(this.breadCrumb.items.length - 1, 1);
                    this.addPayescapeCrumbToBreadcrumbItems();
                }
                else {
                    this.breadCrumb.items.splice(this.breadCrumb.items.length - 1, 1);
                }
            }
        };
        PayescapeProductViewModel.prototype.addPayescapeCrumbToBreadcrumbItems = function () {
            var crumb = Portal.BreadCrumbItem.from("i-Serve");
            crumb.clickAction = function () { Navigator.navigateTo("iServe", "index", "/iServe", null); };
            this.breadCrumb.items.push(crumb);
        };
        PayescapeProductViewModel.prototype.getPayescapeProductDetails = function () {
            this.node = Portal.Context.shell.findNodeByUID(this.shopId);
        };
        PayescapeProductViewModel.prototype.createPayescapeProductDetailsCrumb = function () {
            var crumb = Portal.BreadCrumbItem.from(this.node.name);
            this.breadCrumb.items.push(crumb);
        };
        PayescapeProductViewModel.prototype.selectTab = function (index) {
            this.tabSelected = index;
        };
        return PayescapeProductViewModel;
    }(Common.ViewModelBase));
    var instance = new PayescapeProductViewModel();
    return instance;
});

